<template>
  <uni-popup
    ref="msInviteReferral"
    :mask="true"
    :maskClick="true"
    type="bottom"
    @change="changePopup"
  >
    <div class="ms-invite-referral" @touchstart.stop @click.stop>
      <div class="popup-header">
        <div class="close">
          <uni-icons type="closeempty" color="#666" @click="close" />
        </div>
        <div class="title">邀请专业支持</div>
      </div>
      <div class="content-wrap">
        <div class="show-wrap">
          <div class="label">受者姓名</div>
          <div class="content">{{ formData.patientName }}</div>
        </div>
        <div class="show-wrap">
          <div class="label">性别</div>
          <div class="content">
            {{ getKeyValueText('sex_code', formData.patientSex) }}
          </div>
        </div>
        <div class="show-wrap">
          <div class="label">年龄</div>
          <div class="content">
            {{ formData.patientAge }}
          </div>
        </div>
        <div class="show-wrap">
          <div class="label">转入科室</div>
          <div class="content">
            {{ formData.deptName }}
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="cancel" @click="close">取消</div>
        <div class="submit" @click="onSaveReport">确定</div>
      </div>
    </div>
  </uni-popup>
</template>

<script>
import { applyForReferral } from '@/views/funcPuzzle/utils/index.js'
import { showModal, getKeyValueText, birthToAge } from '@/views/funcPuzzle/utils/util.js'

export default {
  props: {
    value: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      formData: {}
    }
  },
  methods: {
    getKeyValueText,
    initPropsValue(data) {
      // console.log('initPropsValue--', data)
      // 受者年龄
      if (!data) {
        data = {}
      }
      const patientAge = birthToAge(data.patientBirth)
      // 初始数据
      this.formData = {
        type: data.visitType === '5' ? 2 : 1, // 1:转诊申请（下级发起） 2:转诊邀请(上级发起)
        visitID: data.visitID,
        applyDoctorID: data.lowerDoctorID || '',
        applyHospitalID: data.lowerHospitalID || '',

        toHospitalID: data.hospitalID || '',
        toDeptID: data.deptID || '',
        deptName: data.deptName || '',

        patientName: data.patientName || '',
        patientSex: data.patientSex || '',
        patientCardNo: '', // 身份证号是脱敏所以不穿
        patientAge,
        patientPhone: '', // 手机号是脱敏所以不穿
        patientAddress: data.address || '',

        preImpress: '',
        medicalCurrentDesc: data.medicalCurrentDesc || '',
        medicalHistoryDesc: data.medicalHistoryDesc || '',
        treatProcess: ''
      }
    },
    // 打开
    open() {
      this.$refs.msInviteReferral.open()
    },
    // 关闭
    close() {
      this.$refs.msInviteReferral.close()
    },
    // 打开/关闭popup
    changePopup({ show }) {
      if (show) {
        this.$emit('input', null)
      }
    },
    // 确认
    async onSaveReport() {
      try {
        const { code, codeDesc } = await applyForReferral({
          ...this.formData,
          patientAge: this.formData.patientAge ? this.formData.patientAge.split('岁')[0] : ''
        })

        if (String(code) !== '0') {
          showModal({
            title: '温馨提示',
            content: codeDesc,
            showCancel: false
          })
          return
        }
        showModal({
          title: '温馨提示',
          content: codeDesc || '保存成功',
          showCancel: false
        })
        close()
      } catch (e) {
        console.log(e)
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          initPropsValue(val)
          open()
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin iosPadding($pos) {
  padding-#{$pos}: constant(safe-area-inset-#{$pos});
  padding-#{$pos}: env(safe-area-inset-#{$pos});
}

@mixin ellipsis($line: 1) {
  @if $line > 1 {
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: $line; //行数
    line-clamp: $line;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    word-break: break-all;
    overflow: hidden;
  } @else {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.ms-invite-referral {
  height: 17.92rem;
  border-radius: 0.853333rem 0.853333rem 0 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;

  @include iosPadding(bottom);
  .popup-header {
    flex: 0 0 auto;
    position: relative;
    padding: 0.426667rem 0.682667rem;
    display: flex;
    align-items: center;
    border-radius: 0.853333rem 0.853333rem 0 0;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 4;
      height: 0.042667rem;
      background: #ececec;
      transform: scaleY(0.5);
    }
    .title {
      flex: 1;
      font-size: 0.725333rem;
      line-height: 0.938667rem;
      font-weight: 500;
      color: #171a1d;
      text-align: center;
    }
    .close {
      // 图标太小展位大点好点击
      flex: 0 0 auto;
    }
  }

  .content-wrap {
    flex: 1;
    overflow-y: auto;

    .show-wrap {
      position: relative;
      padding-left: 0.682667rem;
      padding-right: 0.682667rem;
      display: flex;
      align-items: center;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 4;
        height: 0.042667rem;
        background: #ececec;
        transform: scaleY(0.5);
      }

      .label {
        padding-right: 0.256rem;
        display: flex;
        flex: 0 0 auto;
        font-size: 0.64rem;
        line-height: 2.005333rem;
        font-weight: 400;
        color: #888;
      }

      .content {
        padding-right: 0.256rem;
        padding-bottom: 0.64rem;
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .btn-wrap {
    flex: 0 0 auto;
    background: #fff;
    padding: 0.341333rem 0.682667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0rem -0.085333rem 0.170667rem 0rem rgba(0, 0, 0, 0.05);

    .cancel {
      flex: 0 0 6.912rem;
      width: 6.912rem;
      font-size: 0.682667rem;
      line-height: 1.877333rem;
      text-align: center;
      color: #366ef4;
      border: 0.042667rem solid #366ef4;
      background: #fff;
      border-radius: 0.170667rem;
    }

    .submit {
      @extend .cancel;
      background: #366ef4;
      color: #fff;
    }
  }
}
</style>
